export default function () {
  return {
    showDrawer: false,
    openingHoursPage: {},
  };
}
